import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// slices
import mailReducer from './slices/mail';
import chatReducer from './slices/chat';
import productReducer from './slices/product';
import calendarReducer from './slices/calendar';
import kanbanReducer from './slices/kanban';
import settingsReducer from './slices/settings';
import confirmReducer from './slices/confirm';
import imagePreviewReducer from './slices/imagePreview';
import lookupReducer from './slices/lookup';
import authPagesReducer from './slices/authPages';
import gameReducer from './slices/game';
import addMemberBankDialogReducer from './slices/addMemberBankDialog';
import authUiReducer from './slices/authUiSlice';

// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};

const productPersistConfig = {
  key: 'product',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout'],
};

const rootReducer = combineReducers({
  settings: settingsReducer,
  mail: mailReducer,
  chat: chatReducer,
  calendar: calendarReducer,
  kanban: kanbanReducer,
  confirm: confirmReducer,
  imagePreview: imagePreviewReducer,
  product: persistReducer(productPersistConfig, productReducer),
  lookup: lookupReducer,
  authPages: authPagesReducer,
  game: gameReducer,
  addMemberBankDialog: addMemberBankDialogReducer,
  authUi: authUiReducer,
});

export { rootPersistConfig, rootReducer };
